<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <a href="javascript:void(0)"
        ><span class="see-more-link">آخرین محصولات</span></a
        >
      </div>
    </div>

    <swiper v-if="products.length > 0" ref="mySwiper" :options="swiperOptions">
      <swiper-slide v-for="product in products" :key="product.id">
        <div class="card">
          <div class="sticky-discount" v-if="product.offer > 0">
            <span v-if="product.offer < 100">
              <span>&#37;{{ formatNumber(parseInt(product.offer)) }}</span
              ><span>تخفیف</span></span
            >

            <span v-else>
              <span>{{ formatNumber(parseInt(product.offer)) }}</span
              ><span> تومان تخفیف</span></span
            >
          </div>

          <img
              class="card-img-top"
              :alt="product.name"
              :src="product.thumbnail"
          />
          <div class="card-body card-body-text">


            <router-link class="text-decoration-none text-dark"
                         :to="{ name: 'Product', params: { name: product.raw_link } }">
              <span class="font-weight-bold mt-1 d-block custom-font-size">{{ product.name.slice(0, 50) }}</span>
            </router-link>


            <del v-if="product.offer > 0" class="prices d-block">
              {{
                formatNumber(parseInt(product.price))
              }}
              تومان
            </del>

            <span class="prices">{{
                formatNumber(parseInt(product.price - product.offer))
              }}</span
            ><span class="info mr-1">تومان</span>
            <br/>
            <router-link class="text-decoration-none"
                         :to="{ name: 'Product', params: { name: product.raw_link } }">
              <b-button @click="goToTop()" class="card-button" variant="primary"
              >مشاهده و خرید
                <b-icon icon="cart-fill" class="h2 mr-1 text-white text-bold"/>
              </b-button>

              <span v-if="isProductActive(product)">
                <b-button v-if="IsAuthenticated " @click.prevent="basketAddItem(product)"
                          class="card-button mr-2"
                          variant="primary">
                  <b-icon icon="plus" class="add-shopping-cart-button"/>
                </b-button>
                <b-button v-else @click.prevent="addUnAuthItem(product)" class="card-button mr-2" variant="primary">
                  <b-icon icon="plus" class="add-shopping-cart-button"/>
                </b-button>
              </span>
              <span class="text-decoration-none d-block p-1" v-else>زمان برای خرید این محصول به پایان رسیده است.</span>

            </router-link>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
import {Swiper, SwiperSlide, directive} from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {mapGetters} from "vuex";
import {isProductActive} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Timing";
import {basketAddItem, addUnAuthItem} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";

export default {
  name: "Slider-2",
  components: {Swiper, SwiperSlide, directive},
  props: ["title"],
  data() {
    return {
      swiperOptions: {
        slidesPerView: 4,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          300: {
            slidesPerView: 2,
          },
          480: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          980: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
          }
        }
      },
    };
  },
  computed: {
    ...mapGetters({
      products: "Product/getLatestProduct",
    }),
    IsAuthenticated() {
      return this.$store.getters["User/isAuthenticated"];
    },
  },
  methods: {
    formatNumber,
    isProductActive,
    basketAddItem,
    addUnAuthItem,
    goToTop() {
      window.scroll(0, 0)
    },

  },
  mounted() {
    this.$store.dispatch("Product/getLatestProducts");
  }
};
</script>

<style scoped>
.slider-row {
  padding-top: 20px;
  margin-left: 30px;
  margin-right: 30px;
}

.slider-controls {
  border-bottom: 1px solid #c4c4c4;
}

.see-more-link {
  color: var(--primary);
  font-size: 19px;
  font-weight: bold;
}

.card-button {
  border-radius: 15px;
  color: var(--light-info);
  font-size: 10px;
  font-weight: bold;
}

.card-button:hover {
  border-color: white;
}

.card-body-text {
  text-align: center;
  direction: rtl;
}

.card-body {
  padding: 0px;
  padding-bottom: 5px;
}

.card {
  min-width: 200px;
  height: 375px;
  border-radius: 10px;
  margin: 0px;
  margin-right: 10px;
}

.card > .card-img-top {
  height: 65%;
  border-radius: 10px;
  object-fit: cover;
}

.prices {
  font-weight: bold;
  font-size: 17px;
}

.info {
  font-size: 11px;
  font-weight: bold;
}

.b-icon {
  padding: 0px;
  margin: 0px;
  font-size: 10px;
  color: var(--primary);
}

.sticky-discount {
  padding: 5px;
  position: fixed;
  margin: 10px;
  font-size: 12px;
  font-weight: bold;
  color: white;
  background-color: var(--primary);
  border-radius: 14px;
  border-bottom-right-radius: 0px;
  min-width: max-content;
}

.slider-btn > .b-icon {
  color: var(--primary);
  font-weight: bold;
}

.custom-font-size {
  font-size: 14px;
}


.add-shopping-cart-button {
  font-size: 20px !important;
  color: var(--light-white) !important;
}


</style>